import React from "react";
import './CookieNotice.css';
import {Button, Container, Grid} from "semantic-ui-react";
import {Trans, withNamespaces, WithNamespaces} from "react-i18next";
import { useCookies } from 'react-cookie';


const COOKIES_ACCEPTED_COOKIE = 'InfosysCookieNoticeAccepted';

export const CookieNotice = withNamespaces()((props: WithNamespaces) => {
  const {t} = props;
  const [cookies, setCookie] = useCookies([COOKIES_ACCEPTED_COOKIE]);

  const isAccepted = cookies[COOKIES_ACCEPTED_COOKIE] === 'yes';
  const accept = () => {
    const expiryDate = new Date();
    expiryDate.setTime(expiryDate.getTime() + (365*24*60*60*1000));
    setCookie(COOKIES_ACCEPTED_COOKIE, 'yes', {
      path: '/',
      expires: expiryDate
    });
  };

  if(isAccepted) {
    return null; // do not render notice when already accepted
  }
  return <div className="landgard-cookie-notice">
    <Container>
      <Grid stackable={true}>
        <Grid.Column width="13">
          <Trans i18nKey="CookieNotice.Text">
            <a href={t("CookieNotice.Url")} target="_blank" rel="noopener noreferrer">LINK</a>
          </Trans>
        </Grid.Column>
        <Grid.Column width="3">
          <Button fluid onClick={() => accept()} primary>{t('CookieNotice.ConfirmButton')}</Button>
        </Grid.Column>
      </Grid>
    </Container>
  </div>;
});